var React = require('react');

function More (props) {
    return React.createElement("svg",props,[React.createElement("g",{"transform":"translate(-6.5 -1.25)","key":0},[React.createElement("path",{"d":"M10.5,4.25H13v2.5H10.5Z","transform":"translate(0 1)","key":0}),React.createElement("path",{"d":"M10.5,10.75H13v2.5H10.5Z","key":1}),React.createElement("path",{"d":"M13,17.25H10.5v2.5H13Z","transform":"translate(0 -1)","key":2})]),React.createElement("rect",{"width":"10","height":"22","fill":"none","key":1})]);
}

More.defaultProps = {"width":"10","height":"22","viewBox":"0 0 10 22"};

module.exports = More;

More.default = More;
